import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ManagePermissionsComponent } from '../manage-permissions/manage-permissions.component';
import { ContentDialogGenericComponent } from '@app/shared/components/content-dialog-generic/content-dialog-generic.component';
import { IProfile } from '@app/shared/interfaces';
import { MatTableDataSource } from '@angular/material/table';
import {
  permissionsDictionary,
  permissionsDictionaryTranslate,
} from '../manage-permissions/models/permissions';
import { ProfilesService } from '../../services/profiles/profiles.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-permissions-table',
  templateUrl: './permissions-table.component.html',
  styleUrls: ['./permissions-table.component.sass'],
})
export class PermissionsTableComponent implements OnInit {
  _dataSource: MatTableDataSource<IProfile>;
  permissions: any = permissionsDictionaryTranslate;

  @Output() profileDeleted: EventEmitter<void> = new EventEmitter<void>();
  @Output() loadProfiles: EventEmitter<void> = new EventEmitter<void>();
  @Input() set dataSource(data: IProfile[]) {
    this._dataSource = new MatTableDataSource<IProfile>(data);
  }

  displayedColumns: string[] = ['name', 'roles', 'edit'];

  constructor(
    private dialog: MatDialog,
    private profileService: ProfilesService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {}

  getRolesAsString(roles: any[]): string {
    return roles.map((role) => role.name).join(', ');
  }

  getAttributesAsString(attributes: any[]): string {
    return attributes
      .filter((attribute) => attribute.value)
      .map((attribute) => this.permissions[attribute.name]?.title)
      .join(', ');
  }

  handleOpenModalManage(permission?: IProfile): void {
    const dialogRef = this.dialog.open(ManagePermissionsComponent, {
      data: permission,
      panelClass: 'no-padding-dialog',
      minWidth: '40%',
      minHeight: '90%',
      height: '80%',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.up === true) {
        this.loadProfiles.emit();
      }
    });
  }

  deletePermission(permission?: IProfile): void {
    const dialogRef = this.dialog.open(ContentDialogGenericComponent, {
      data: { message: `Tem certeza que deseja excluir o perfil ${permission.name}?` },
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.profileService.deleteProfile(permission.id).subscribe({
          next: (response) => {
            this.toastr.success('Perfil excluído com sucesso.');
            this.profileDeleted.emit();
          },
          error: (error) => {
            this.toastr.error(error?.errors.join(', '));
          },
        });
      }
    });
  }
}
